import Icon from '@klv/atoms/icon';
import { generateClassName } from '@klv/shared/utils/functions';
import { useTranslation } from '@klv/hooks/useTranslation';
import LinkButton from '@klv/atoms/button/variants/link';
import TranslatedDate from '@klv/atoms/translated-date';

import type { IPostCard } from '../types';

import * as styles from './styles/post-card.module.scss';

const PostCard = ({ ctaText, post }: IPostCard) => {
  const { t } = useTranslation();
  return (
    <div>
      {!!post?.featured?.featuredPostImage ? (
        <img className={styles.image} {...post?.featured?.featuredPostImage} 
          alt={post?.featured?.featuredPostImage.altText} 
        />
      ) : (
        <div className={styles.imagePlaceholder}>
          <Icon className={styles.imagePlaceholderIcon} iconName="BugMarkFilled" fillColor="var(--color-white)" size="auto"/>
        </div>
      )}
      
      <div className={styles.date}><TranslatedDate date={post.date}/></div>
      <div className={styles.taxonomies}>
        {post.resourceCategories?.nodes?.map((c) => (
          <div className={styles.taxonomy} key={c.slug}>{c.name}</div>
        ))}
        {post.resourceCollections?.nodes?.map((c) => (
          <div className={styles.taxonomy} key={c.slug}>{c.name}</div>
        ))}
        {post.resourceStages?.nodes?.map((c) => (
          <div className={styles.taxonomy} key={c.slug}>{c.name}</div>
        ))}
        {post.resourceTopics?.nodes?.map((c) => (
          <div className={styles.taxonomy} key={c.slug}>{c.name}</div>
        ))}
      </div>
      <div className={generateClassName([styles.title, 'semiBold'])}>{post.title}</div>
      <div className={styles.excerpt} dangerouslySetInnerHTML={{ __html:post.excerpt }}/>
      <LinkButton variant="tertiary" url={post.uri}>
        {ctaText ? ctaText : t('organisms_post_filter_read_more')}
      </LinkButton>
    </div>
  );
};

export default PostCard;
